"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const Copy = createSVGIcon(
  <>
    <path
      d="M10.25 8.75V5.75C10.25 5.48478 10.3554 5.23043 10.5429 5.04289C10.7304 4.85536 10.9848 4.75 11.25 4.75H18.25C18.5152 4.75 18.7696 4.85536 18.9571 5.04289C19.1446 5.23043 19.25 5.48478 19.25 5.75V13.75C19.25 14.0152 19.1446 14.2696 18.9571 14.4571C18.7696 14.6446 18.5152 14.75 18.25 14.75H14.25"
      stroke="currentColor"
    />
    <path
      d="M12.25 10.25H5.25C4.97386 10.25 4.75 10.4739 4.75 10.75V18.75C4.75 19.0261 4.97386 19.25 5.25 19.25H12.25C12.5261 19.25 12.75 19.0261 12.75 18.75V10.75C12.75 10.4739 12.5261 10.25 12.25 10.25Z"
      stroke="currentColor"
    />
  </>,
  "Copy",
  { viewBox: "0 0 24 24", titleAccess: "Copy", fill: "none" }
);
